var mentions_default = {
  "mention": "_87Hx1",
  "mentionViewer": "w6M9v",
  "cursorDefault": "XTmuX",
  "cursorPointer": "p10F3"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
